const state = {
  valuation: {},
  sectorValuations: [],
  profitability: [],
  leverage: [],
  technical: [],
  endMarketExposure: [],
  pricePerformance: [],
  stockCorrelation: [],
  mcap: [],
  revenueComposition: [],
};

const getters = {
  valuation: (state) => state.valuation,
  sectorValuations: (state) => state.sectorValuations,
  profitability: (state) => state.profitability,
  leverage: (state) => state.leverage,
  technical: (state) => state.technical,
  endMarketExposure: (state) => state.endMarketExposure,
  pricePerformance: (state) => state.pricePerformance,
  stockCorrelation: (state) => state.stockCorrelation,
  mcap: (state) => state.mcap,
  revenueComposition: (state) => state.revenueComposition,
};

const actions = {
  setSectorValuations ({ commit }, sectorValuations) {
    commit("SET_SECTORVALUATIONS", sectorValuations);
  },
};

const mutations = {
  SET_VALUATION: (state, valuation) => {
    state.valuation = valuation;
  },
  SET_SECTORVALUATIONS: (state, sectorValuations) => {
    
    // sessionStorage.setItem("sectorValuations", JSON.stringify(sectorValuations));
    state.sectorValuations = sectorValuations;
  },
  SET_PROFITABILITY: (state, profitability) => {
    var formattedData = profitability.map(function(d) {
      return {
        // date : parseTime(d.date),
        date : d.date,
        LTM : +d.ltm,
        book : +d.book,
        Yld : +d.yld,
        Shiller : +d.shiller,
        EPS : +d.eps,
        Growth : +d.growth,
        Yield : +d.yield,
        ROE : +d.roe,
        EV_Sales : +d.ev_sales,
        EBITDA : +d.ebitda
      };
    });

    if (formattedData.length > 0)
    sessionStorage.setItem("scatterData", JSON.stringify(formattedData));

    state.profitability = profitability;
  },
  SET_LEVERAGE: (state, leverage) => {
    var formattedData = leverage.map(function(d) {
      return {
        Mcap: d.mcap,
        Rating: d.rating,
        YTD: d.ytd,
        fcfYield: d.fcfyield,
        fullname: d.fullname,
        name: d.name,
        netDebt: d.netdebt,
        type: d.type,
        year: d.year
      };
    });
    sessionStorage.setItem("bubbleData", JSON.stringify(formattedData));
    state.leverage = leverage;
  },
  SET_TECHNICAL: (state, technical) => {
    var formattedData = technical.map(function(d) {
      return {
        name : d.name,
        Beta : +d.beta,
        FY2 : +d.fy2,
        "100D" : +d['100d'],
        "200D" : +d['200d'],
      };
    });
    
    sessionStorage.setItem("scatterData1", JSON.stringify(formattedData));
    state.technical = technical;
  },
  SET_ENDMARKETEXPOSURE: (state, endMarketExposure) => {
    sessionStorage.setItem("heatMapData", JSON.stringify(endMarketExposure));
    state.endMarketExposure = endMarketExposure;
  },
  SET_PRICEPERFORMANCE: (state, pricePerformance) => {
    sessionStorage.setItem("treeMapChartData", JSON.stringify(pricePerformance));
    state.pricePerformance = pricePerformance;
  },
  SET_STOCKCORRELATION: (state, stockCorrelation) => {
    let formattedData = stockCorrelation.map(function(d){
      // console.log('shakti->',d)
      return {
        Name: d.name,
        AGCO: parseFloat(d.agco).toFixed(1),
        CAT: parseFloat(d.cat).toFixed(1),
        CMI: parseFloat(d.cmi).toFixed(1),
        DE: parseFloat(d.de).toFixed(1),
        ETN: parseFloat(d.etn).toFixed(1),
        IR: parseFloat(d.ir).toFixed(1),
        ITW: parseFloat(d.itw).toFixed(1),
        KMT: parseFloat(d.kmt).toFixed(1),
        MTW: parseFloat(d.mtw).toFixed(1),
        NAV: parseFloat(d.nav).toFixed(1),
        OSK: parseFloat(d.osk).toFixed(1),
        PCAR: parseFloat(d.pcar).toFixed(1),
        PH: parseFloat(d.ph).toFixed(1),
        RBA: parseFloat(d.rba).toFixed(1),
        RBC: parseFloat(d.rbc).toFixed(1),
        TEX: parseFloat(d.tex).toFixed(1),
        TKR: parseFloat(d.tkr).toFixed(1),
        TWI: parseFloat(d.twi).toFixed(1)
      };
    });
    sessionStorage.setItem("stockCorrData", JSON.stringify(formattedData));
    state.stockCorrelation = stockCorrelation;
  },
  SET_MCAP: (state, mcap) => {
    let formattedData = mcap.map(function(d){
      return {
        Name: d.name,
        Ticker: d.ticker,
        Value: d.value,
        Year: d.year
      };
    });
    sessionStorage.setItem("mcap", JSON.stringify(formattedData));
    state.mcap = mcap;
  },
  SET_REVENUECOMPOSITION: (state, revenueComposition) => {
    sessionStorage.setItem("circleData", JSON.stringify(revenueComposition));
    state.revenueComposition = revenueComposition;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
